<template>
  <div v-if="showComponent && onReady" :key="componentRefresh">
    <single-select-button
        @onMounted="selectorMounted"
        :disabled="disabled"
        :label="label"
        :options="options"
        :optionValue="optionValue"
        :optionLabel="optionLabel"
        :optionFilter="optionFilter"
        :buttonClass="buttonClass"
        :buttonPadding="buttonPadding"
        :buttonMargin="buttonMargin"
        :buttonDropdownMargin="buttonDropdownMargin"
        v-model="input"
        :showLabel="showLabel"
        @onChange="onChange"
    />
  </div>
</template>

<script>
import Vuex from 'vuex';
import checkPermissions from '../../../mixins/checkPermissions';
import dataproviderOptionsValidation from './../mixins/index.js';
import single_select_button from './../selector-types/single-select-button';

export default {
  name: "ks-single-selector-button",
  mixins: [checkPermissions, dataproviderOptionsValidation],
  components: {
    'single-select-button': single_select_button
  },
  props: {
    value: {},
    dataSource: {
      type: String,
      default: null
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    },
    defaultValue: {},
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      default: () => []
    },
    optionValue: {
      type: String,
      default: null
    },
    optionLabel: {
      type: String,
      default: null
    },
    optionFilter: {
      default: null
    },
    buttonClass: {
      default: "btn btn-primary"
    },
    buttonPadding: {
      default: ""
    },
    buttonMargin: {
      default: ""
    },
    buttonDropdownMargin: {
      default: ""
    },
    returnType: {
      type: String,
      default: null
    }
  },
  watch: {
    input: function (val, oldVal) {
      //enable for testing
    },
    defaultValue: function (val) {
      this.input = val;
    },
    value(val) {
      this.cValue = val;
    },
    cValue(val) {
      this.$emit('input', val);
    }
  },
  computed: {
    ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
    inputType() {
      return this.$parent.type;
    },
    input: {
      get() {
        if (this.dataSource != null && this.$parent.data_provider_ref) {
          if (this.inputType === 'list') {
            return this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
          } else {
            if (this.returnType === "string") {
              return this.$parent.data_provider_ref[this.inputType][this.dataSource] ? this.$parent.data_provider_ref[this.inputType][this.dataSource].toString() : '';
            } else {
              return this.$parent.data_provider_ref[this.inputType][this.dataSource];
            }
          }
        } else {
          return this.cValue;
        }
      },
      set(newval) {
        if (this.dataSource != null && this.$parent.data_provider_ref) {
          if (this.inputType === 'list') {
            this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, newval);
          } else {
            this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, newval);
          }
        } else {
          this.cValue = newval;
        }
      }
    }
  },
  methods: {
    selectorMounted(evt) {
      setTimeout(() => {
        if (!this.dataSource != null) {
          this.cValue = this.value;
        } else if (typeof this.defaultValue !== 'undefined') {
          this.input = this.defaultValue;
        }
        this.$emit('onMounted', evt);
      }, 100)
    },
    onChange(evt) {
      this.$emit('onChange', this);
    }
  },
  data() {
    return {
      cValue: null
    }
  }
}
</script>
